module.exports = __webpack_public_path__ + "img/exemplo-produto-cadeira.de64eebe.jpg";